import { apiGet, unwrap } from './apiClient';
import { ResponseDTO, PrivilegeDTO } from '@/types/api';

export interface ResourceDTO {
  id: string;
  name: string;
  description: string | null;
}

/**
 * List available resources (privileges) that can be assigned permissions.
 * Maps from the backend PrivilegeDTO to the UI Resource shape.
 */
export async function listResources(): Promise<ResourceDTO[]> {
  const res = await apiGet<ResponseDTO<PrivilegeDTO[]>>('/api/v1/privileges');
  const privileges = unwrap(res);
  return privileges.map((p) => ({
    id: p.code,
    name: p.code,
    description: p.description || null,
  }));
}
